import { useState, useEffect } from 'react';
import { SnackbarProps, UseSnackbarReturn } from './types';

/**
 * Snackbarコンポーネントのロジックを管理するカスタムフック
 */
export const useSnackbar = ({
  open,
  closeButtonDuration = 3000
}: Pick<SnackbarProps, 'open' | 'closeButtonDuration'>): UseSnackbarReturn => {
  const [shouldRender, setShouldRender] = useState<boolean>(open);
  const [showCloseButton, setShowCloseButton] = useState<boolean>(true);
  
  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (open) {
      setShouldRender(true);
      setShowCloseButton(true);
      if (closeButtonDuration > 0) {
        timer = setTimeout(() => {
          setShowCloseButton(false);
        }, closeButtonDuration);
      }
    } else {
      // 閉じるアニメーションのために少し待つ
      timer = setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
    return () => clearTimeout(timer);
  }, [open, closeButtonDuration]);

  return {
    shouldRender,
    showCloseButton
  };
};

export default useSnackbar; 